<div class="d-flex flex-column gap-4 p-3 w-100" style="background: var(--neutral-white, #FFF);">
  <!-- ... existing content ... -->
  <div class="d-flex justify-content-between align-items-center pb-3 border-bottom border-2">
    <div class="fs-5 fw-bold">Current Instant Rates</div>
  </div>

  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex gap-2">
      <button type="button" (click)="openCreateRateModal()"
        class="btn btn-secondary text-white d-flex align-items-center">
        <i class="bi bi-plus-circle me-2"></i>Add Rate</button>

      <button type="button" (click)="openBulkCreateRateModal()"
        class="btn btn-outline-secondary d-flex align-items-center">
        <i class="bi bi-file-earmark-arrow-up me-2"></i>Import</button>
    </div>

    <button class="btn btn-light d-flex align-items-center gap-2" type="button" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left"></i>
      Back to Instant Rate Manager
    </button>
  </div>

  <div class="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
    <div class="d-flex flex-wrap align-items-center gap-3 flex-grow-1" style="min-width: 250px;">
      <!-- <div #groupContainer class="position-relative flex-grow-1 group-select"
        style="min-width: 100px; max-width: 200px;">
        <ng-select #groupSelector class="w-100 custom-select-icon no-caret" [items]="groupArray"
          (change)="onGroupChange($event)" placeholder="Search by group">
        </ng-select>
        <i
          class="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted pointer-events-none"></i>
      </div> -->
      <div class="flex-grow-1" style="min-width: 100px; max-width: 200px;">
        <ng-select class="w-100" [items]="rateCategoryArray" (change)="onRateCategoryChange($event)"
          placeholder="Select rate category"></ng-select>
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-center gap-2 flex-shrink-0">

      <div class="btn-group" role="group">
        <button class="btn btn-outline-secondary d-flex align-items-center" type="button"
          (click)="downloadCsvRate('all')" [disabled]="totalRates === 0">
          <i class="bi bi-download me-2"></i>
          Export as CSV
        </button>
        <div class="btn-group" ngbDropdown role="group">
          <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
            ngbDropdownToggle [disabled]="totalRates === 0">
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <button ngbDropdownItem (click)="downloadCsvRate('all')">All Records</button>
            <button ngbDropdownItem (click)="downloadCsvRate('current')">Current Page</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-end align-items-center w-100 gap-3">
    <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module"
      (onClearFilters)="clearFiltersExternally()"></app-saved-search>
  </div>

  <div *ngIf="selectedRowCount > 0" class="d-flex flex-wrap align-items-center gap-2 p-2 rounded mb-2"
    style="background-color: #E3F2FD; border: 1px solid #90CAF9;">
    <i class="bi bi-check2-square text-primary"></i>
    <span class="fw-semibold">{{ selectedRowCount }} rate(s) selected</span>
    <div class="ms-auto d-flex flex-wrap gap-2">
      <button class="btn btn-primary btn-sm" type="button" (click)="openBulkUpdateModal()">
        <i class="bi bi-pencil-square me-1"></i>Bulk Update
      </button>
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="clearSelection()">
        Clear Selection
      </button>
    </div>
  </div>

  <div *ngIf="hasPendingEdits" class="d-flex align-items-center gap-2 p-2 rounded mb-2"
    style="background-color: #FFF9C4; border: 1px solid #FDD835;">
    <i class="bi bi-pencil-square text-warning"></i>
    <span class="fw-semibold">{{ pendingEdits.size }} rate(s) modified</span>
    <div class="ms-auto d-flex gap-2">
      <button class="btn btn-outline-secondary btn-sm" (click)="discardPendingEdits()">
        <i class="bi bi-x-circle me-1"></i>Discard
      </button>
      <button class="btn btn-primary btn-sm" (click)="submitPendingEdits()">
        <i class="bi bi-check-circle me-1"></i>Submit Changes
      </button>
    </div>
  </div>

  <ag-grid-angular class="ag-theme-alpine w-100" style="height: 600px;" [columnDefs]="columnDefs"
    [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
    [appSavedSearchSync]="savedSearch" (gridReady)="onGridReady($event)" (selectionChanged)="onSelectionChanged()"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>

<ng-template #bulkUpdateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Bulk Update Selected Rates</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body d-flex flex-column gap-3">
    <p class="text-muted mb-0">Update one field across {{ selectedRowCount }} selected rate(s). Changes are staged until
      you click Submit Changes.</p>
    <div>
      <label class="form-label fw-semibold">Field</label>
      <select class="form-select" [(ngModel)]="bulkUpdateField" (ngModelChange)="onBulkUpdateFieldChange()">
        <option value="" disabled>Select field</option>
        <option *ngFor="let field of getBulkUpdateFields()" [value]="field.field">{{ field.label }}</option>
      </select>
    </div>
    <div *ngIf="isTransitDaysBulkUpdate">
      <label class="form-label fw-semibold">Transit Days Action</label>
      <select class="form-select" [(ngModel)]="bulkTransitDaysMode">
        <option *ngFor="let option of bulkTransitDaysModeOptions" [value]="option.value">{{ option.label }}</option>
      </select>
      <small class="text-muted">
        {{ bulkTransitDaysMode === 'add_on_top'
        ? 'Adds the value below to each rate\'s existing transit days.'
        : 'Replaces each rate\'s transit days with the value below.' }}
      </small>
    </div>
    <div *ngIf="selectedBulkFieldConfig as fieldConfig">
      <label class="form-label fw-semibold">{{ isTransitDaysBulkUpdate && bulkTransitDaysMode === 'add_on_top' ? 'Days
        to Add' : 'New Value' }}</label>
      <select *ngIf="fieldConfig.type === 'select'" class="form-select" [(ngModel)]="bulkUpdateValue">
        <option *ngFor="let option of fieldConfig.options" [value]="option">{{ option }}</option>
      </select>
      <input *ngIf="fieldConfig.type === 'number'" type="number" class="form-control" [(ngModel)]="bulkUpdateValue"
        min="0" />
      <input *ngIf="fieldConfig.type === 'text'" type="text" class="form-control" [(ngModel)]="bulkUpdateValue" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="applyBulkUpdate(modal)" [disabled]="!bulkUpdateField">
      Apply to Selected
    </button>
  </div>
</ng-template>
